<template>
  <div class="component-container">
    <div class="second-edition" id="second-edition">
      <h3>5ENG Second Edition: Earth and Space Systems - Downloads and Resources</h3>
      <div class="back-button-wrapper">
        <button type="button" @click.prevent="cancelButton" class="back-button">Back to Main Dashboard</button>
      </div>

      <div class="presentations">
        <h4>Teacher Presentations</h4>
        <p>Please download and save to your Google drive for your classroom. Presentation can be used in Google slides or Powerpoint.</p>
        <ul>
        <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-online-prototype.appspot.com/o/activityPresentations%2FJanuary%202026%20Updates%2F5ENG-2E%20Activities%201-7-20260112T163145Z-3-001.zip?alt=media&token=491e57e2-2747-42ad-af4c-66ed03b33569" target="_blank">Activities 1-7 (Zip File) Updated 1/12/2026</a></li>
        <li><a href="https://docs.google.com/spreadsheets/d/1RZrQWEcgAu2kxE60cdaDCwpFOj35RFvl_ZiPRYWxAXw/edit?usp=sharing" target="_blank">Teacher Guide Links</a> - A spreadsheet of all of the links in our K-5 Teacher Guides (Updated 4/24/2024) - Report broken links to info@bcamsc.org.</li>
        <li><a href="https://docs.google.com/spreadsheets/d/1qe8R8GD92WO6dtzWri9pKbKWjAYx2siuRzdE8bcT_6c/edit?gid=129442248#gid=129442248">Curriculum Updates Spreadsheet</a> - List of links to updates for printed materials.</li>
      </ul>
        
      </div>
      <div class="presentations">
        <h4>Student Journals</h4>
        <p>Please make a master copy for your classroom and save to your Google drive for your classroom.</p>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/1D6IHvmyWjyouj7U7-uCB07UQNuc9Thfy4sUxKl761G0/copy" target="_blank">5ENG 2nd Edition: Earth and Space Systems Student Journal</a></li>
          <li><a href="https://drive.google.com/file/d/1ut5WyuwpDKRSTOSpUWECAuRI_Cx9Qo8O/view" target="_blank">5ENG 2nd Edition: Earth and Space Systems Student Journal Answer Key (Updated 8/30/2023)</a></li>
          <li><a href="https://docs.google.com/presentation/d/1dArBuadDUdQr7_B3gmQVPT2csv8FobXTebdKR9UI4Xs/copy" target="_blank">5ENG 2nd Edition: Earth and Space Systems Student Journal - SPANISH</a></li>
        </ul>

      </div>
      <div class="presentations">
        <h4>Individual Resources</h4>
        <p>The resources below are also linked in the Teacher Led Presentations. We've provided them here for anyone wishing to have access to these individual resources outside of the presentations. Please make master copies of Jamboards and Slide Decks and save in your Google drive for your classroom.</p>
      <h4 style="margin-left: 10px;">Charts, Handouts, Card Sets, etc.</h4>
      <ul>
        <li><a href="https://docs.google.com/presentation/d/14wrrvFrR4smwOG6r69ygrKqGqu_dYvVt7-dKmnGYxMI/copy" target="_blank">What We Think Chart</a></li>
        <li><a href="https://docs.google.com/presentation/d/1e3wEZfMoEQaquCHBbKPN4YeGqnoZj1p1x4zJy4MTjtk/copy" target="_blank">Word Wall</a></li>
        <li><a href="https://docs.google.com/document/d/1qw5iiUy788QClzZ42EVK6RSFLhsY7gSqzq17wPKltio/copy" target="_blank">Parent Letter and Water Use Handout - Lesson 3B</a></li>
        <li><a href="https://docs.google.com/presentation/d/17SsGkuEwyiHPeTgkD34_2jYYYXabnNKVg2jkbGJhDF4/copy" target="_blank">Relationship Between Sun, Earth, and Constellations</a></li>
        <li><a href="https://docs.google.com/presentation/d/1OrmNOpv-cygB0T6Q0r_Qsqa5sbVyAVojYtwExJmli9M/copy" target="_blank">Zodiac Sign Cards</a></li>
          <!-- <li><a href="" target="_blank"></a></li> -->
        </ul>
      </div>
    </div>
  </div>
  </template>

  <script>
  import { mapState } from 'vuex'

  export default {
  data() {
    return {}
  },
  computed: {
    ...mapState([ 'dashboardView', 'userProfile' ])
  },
  methods: {
    cancelButton() {
      this.$store.commit('SET_DASHBOARD_VIEW', 'units')
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
  }
  </script>

  <style lang="css" scoped>
  .presentations {
  border: 1px solid grey;
  text-align: left;
  padding: 20px;
  margin: 0 20px 20px 20px;
  }
  ul {
  list-style: none;
  }
  .presentations a {
  margin-left: 40px;
  }
  li {
  margin-left: -40px;
  }
  .back-button-wrapper {
  width: 100%;
  text-align: left;
  margin-bottom: 0;
  }
  .back-button {
  background: white;
  border: none;
  font-weight: 600;
  color: #7b8a1d;
  margin-left: 20px;
  }
  </style>
